#import "../fragments/digest-subscription-fragment.graphql"

mutation UpdateDigestSubscription($input: DigestSubscriptionUpdateInput!) {
    digestSubscriptionUpdate(input: $input) {
        subscription {
            ...DigestSubscriptionFragment
        }
        nextSendDate
    }
}
